import { render, staticRenderFns } from "./MultiZoneStandart.vue?vue&type=template&id=5990664e&scoped=true&"
import script from "./MultiZoneStandart.vue?vue&type=script&lang=js&"
export * from "./MultiZoneStandart.vue?vue&type=script&lang=js&"
import style0 from "./MultiZoneStandart.vue?vue&type=style&index=0&id=5990664e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990664e",
  null
  
)

export default component.exports